import { LanguageService } from './../../../Services/languageService';
import { Subscription } from 'rxjs';
import { userService } from './../../../Services/userService';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';
import { ProposalModel } from '../../../Models/ProposalModel'
import { proposalResMdl } from '../../../Models/proposalResMdl'
import { RegModel } from '../../../Models/RegModel';
import { renewPolicyModel } from '../../../Models/policyModel';
import { MotorStatusMdl } from '../../../Models/MotorStatusMdl';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';

@Component({
    selector: 'RenewalPolicy',
    templateUrl: './RenewalPolicy.html',
    styleUrls: ['./RenewalPolicy.css']
})
export class RenewalPolicy {

    public isShowLoading: boolean = false;
    public renewObj: renewPolicyModel = new renewPolicyModel();
    public st: MotorStatusMdl = new MotorStatusMdl();
    public LngSubscription: Subscription;
    public Lng: string;
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();


    constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private userinfo: userService, private lngService: LanguageService) {
        this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
        //this.renewObj = JSON.parse(sessionStorage.getItem("renewObj"));
        this.renewObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("renewObj")));
    }

    proceedToRenew() {
        this.renewObj.InsuredToken = sessionStorage.getItem("InsuredToken")
        if (!this.renewObj.SequenceNo) {
            this.Lng == "ar" ? Swal("Please Enter Valid Sequence No") : Swal("Please Enter Valid Sequence No");
            return false;
        }

        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.renewObj));
        this.isShowLoading = true;
        //this.http.post<MotorStatusMdl>(this.url.baseURL + "/RenewPolicy/RenewPolicy", this.renewObj, this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/RenewPolicy/RenewPolicy", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise().then((result) => {
                this.isShowLoading = false;
                //this.st = result;
                //New Line Start
                this.objPayloadResponse = result;
                this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                //NewLine End


                //sessionStorage.setItem("renewObj",JSON.stringify(this.renewObj))
                sessionStorage.setItem("renewObj", this.EncriptService.EncriptObject(JSON.stringify(this.renewObj)));

                if (this.st.StatusCode == "S") {
                    sessionStorage.setItem("CurrentRoute", "RenewalBasicInfo");
                    this.router.navigate(['NewDashboard/RenewalProposal/RenewalBasicInfo']);
                }
                else {
                    this.Lng == "ar" ? Swal(this.st.StatusDescAr) : Swal(this.st.StatusDesc);
                }

            },
                (error) => {
                    this.isShowLoading = false;
                    this.userinfo.checkTokenStatus(error);

                });


    }

    Cancel() {
        this.router.navigate(['/NewDashboard/Policy']);
    }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalPolicy/RenewalPolicy.ts